import React, { useState } from 'react';

const Header = () => {
  const [user] = useState(JSON.parse(localStorage.getItem('user')));
  return (<>
    <div className="br-header">
      <div className="br-header-left">
        <div className="navicon-left hidden-md-down"><a id="btnLeftMenu" href="/"><i className="icon ion-navicon-round" /></a></div>
        <div className="navicon-left hidden-lg-up"><a id="btnLeftMenuMobile" href="/"><i className="icon ion-navicon-round" /></a></div>
        <div className="input-group hidden-xs-down wd-170 transition">
          <input id="searchbox" type="text" className="form-control" placeholder="Search" />
          <span className="input-group-btn">
            <button className="btn btn-secondary" type="button"><i className="fa fa-search" /></button>
          </span>
        </div>
      </div>
      <div className="br-header-right">
        <nav className="nav">          
          <div className="dropdown">
            <a href="app.html" className="nav-link nav-link-profile" data-toggle="dropdown">
              <span className="logged-name hidden-md-down">{user.firstname} {user.lastname}</span>
              {user.profile_pic?
              <><img id="profile_pic" src={`${localStorage.getItem('basurl')}/uploads/${user.profile_pic}`} className="wd-32 rounded-circle" alt="" /><span className="square-10 bg-success" /></>
              :<><span className="wd-32 rounded-circle tx-bold tx-16" style={{border: '1px solid #ccc', padding: '10px 16px'}}>{user.firstname.charAt(0).toUpperCase()}</span></>
              }
              
            </a>
            <div className="dropdown-menu dropdown-menu-header wd-200">
              <ul className="list-unstyled user-profile-nav">
                {/*<li><a href="/"><i className="icon ion-ios-person" /> Edit Profile</a></li>
                <li><a href="app.html"><i className="icon ion-ios-gear" /> Settings</a></li>
                <li><a href="app.html"><i className="icon ion-ios-download" /> Downloads</a></li>
                <li><a href="app.html"><i className="icon ion-ios-star" /> Favorites</a></li>
                <li><a href="app.html"><i className="icon ion-ios-folder" /> Collections</a></li>*/}
                <li><a href="/logout"><i className="icon ion-power" /> Sign Out</a></li>
              </ul>
            </div>{/* dropdown-menu */}
          </div>{/* dropdown */}
        </nav>
      </div>
    </div>
  </>)
}

export default Header;